export default __webpack_public_path__ + "static/media/logo1.f40764a4.png";